import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react"; // или замени на свои иконки стрелок
import { useAppContext } from "../../context/AppContext";
import { LandingTrans } from "../../utils/translations";
import { reviewsData } from "../../utils/reviewsData";

export { reviewsData };

const ReviewsSection = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const { language } = useAppContext();

    const prevReview = () => {
        setCurrentIndex((prev) =>
            prev === 0 ? reviewsData[language].length - 1 : prev - 1
        );
    };

    const nextReview = () => {
        setCurrentIndex((prev) =>
            prev === reviewsData[language].length - 1 ? 0 : prev + 1
        );
    };

    return (
        reviewsData[language].length ? <section className="relative bg-transparent py-14 px-6 w-full font-sans font-light">
            <h2 className="font-serif font-medium text-ink text-center mb-4 md:mb-12" style={{ fontSize: 'clamp(36px, 5vw, 56px)', lineHeight: 1.1 }}>{LandingTrans[language].reviews}</h2>

            {/* Стрелка влево */}
            <button
                onClick={prevReview}
                className="absolute left-0 md:left-4 top-1/2 transform -translate-y-1/2 text-ink-mid hover:text-clay transition"
            >
                <ChevronLeft size={40} />
            </button>

            {/* Стрелка вправо */}
            <button
                onClick={nextReview}
                className="absolute right-0 md:right-4 top-1/2 transform -translate-y-1/2 text-ink-mid hover:text-clay transition"
            >
                <ChevronRight size={40} />
            </button>

            {/* Контент отзыва */}
            <div className="max-w-xl mx-auto flex flex-col items-center text-center">
                {/* Текст */}
                <p className="text-lg font-sans font-light leading-relaxed text-ink-mid mb-6 px-4">
                    {reviewsData[language][currentIndex].text}
                </p>

                {/* Имя автора */}
                <p className="text-base font-sans font-medium text-clay mb-6">
                    — {reviewsData[language][currentIndex].name}
                </p>

                {/* Точки-индикаторы */}
                <div className="flex justify-center gap-3 mt-6">
                    {reviewsData[language].map((_, index) => (
                        <div
                            key={index}
                            className={`w-3 h-3 rounded-full ${index === currentIndex ? "bg-clay" : "bg-sand-dark/50"} transition`}
                        />
                    ))}
                </div>
            </div>
        </section> : ""
    );
};

export default ReviewsSection;
